import { useWorkspace } from '../contexts/WorkspaceContext';
import { usePreferences } from '../contexts/PreferencesContext';

/**
 * Whether Goals is on in the workspace that is open (MI-342).
 *
 * Goals follows the workspace's Owner: it shows for everyone in a workspace
 * whose Owner turned it on in Settings, whatever their own switch says. So an
 * Advisor sees a client's goals without opting in, and nobody sees them where
 * the Owner has them off.
 *
 * An Owner reads their own preference, so flipping the switch acts at once
 * and the first paint comes from the local cache. Anyone else reads what the
 * server said about this workspace (`goals_enabled` on `GET /workspaces`),
 * which is fetched once per page load.
 */
export default function useGoalsEnabled() {
  const { current } = useWorkspace();
  const { isFeatureEnabled } = usePreferences();
  if (current?.workspace_role === 'Owner') return isFeatureEnabled('goals');
  return current?.goals_enabled === true;
}
